export const NAME_SIGN_UP_FIELD_ID = 'nameSignUpField';

export const MAGIC_LINK_EMAIL_FIELD_ID = 'magicLinkEmail';

export const EMAIL_SIGN_UP_FIELD_ID = 'emailSignUpField';
export const EMAIL_SIGN_IN_FIELD_ID = 'emailSignInField';

export const REQUEST_PASSWORD_RESET_EMAIL_FIELD_ID = 'passwordResetEmailField';
export const REQUEST_PASSWORD_RESET_EMAIL_FIELD_HELPER_ID =
  'passwordResetEmailFieldHelper';
export const REQUEST_PASSWORD_RESET_SUBMIT_BUTTON_ID =
  'passwordResetSubmitButton';
export const REQUEST_PASSWORD_RESET_SUCCESS_MESSAGE_ID =
  'passwordResetSuccessMessage';
export const REQUEST_PASSWORD_RESET_ERROR_MESSAGE_ID =
  'passwordResetErrorMessage';

export const RESET_PASSWORD_TOKEN_ERROR_ID = 'resetPasswordTokenError';
export const RESET_PASSWORD_ERROR_MESSAGE_ID = 'resetPasswordErrorMessage';
export const RESET_PASSWORD_NEW_PASSWORD_FIELD_ID =
  'resetPasswordNewPasswordField';
export const RESET_PASSWORD_NEW_PASSWORD_CONFIRMATION_FIELD_ID =
  'resetPasswordNewPasswordConfirmationField';
export const RESET_PASSWORD_SUBMIT_BUTTON_ID = 'resetPasswordSubmitButton';
export const RESET_PASSWORD_SUCCESS_MESSAGE_ID = 'resetPasswordSuccessMessage';
export const RESET_PASSWORD_NEW_PASSWORD_FIELD_ERROR_TEXT_ID =
  'resetPasswordNewPasswordErrorText';
export const RESET_PASSWORD_NEW_PASSWORD_CONFIRMATION_FIELD_ERROR_TEXT_ID =
  'resetPasswordNewPasswordConfirmationErrorText';
export const RESET_PASSWORD_BACK_TO_LOGIN_BUTTON_ID =
  'resetPasswordBackToLoginButton';

export const PASSWORD_SIGN_IN_FIELD_ID = 'passwordSignInField';
export const PASSWORD_SIGN_IN_BUTTON_ID = 'passwordSignInButton';
export const SIGN_UP_AGREEMENTS_CHECKBOX_ID = 'signUpAgreementsCheckbox';
export const SIGN_IN_BUTTON_ID = 'signInButton';
export const SIGN_UP_BUTTON_ID = 'signUpButton';
export const SIGN_IN_HEADER_ID = 'signInHeader';
export const SIGN_UP_HEADER_ID = 'signUpHeader';
export const SIGN_UP_SAVE_ACTIONS_ID = 'signUpSaveActions';
export const EMAIL_SIGN_IN_METHOD_BUTTON_ID = 'emailSignInMethodButton';
export const USER_SWITCH_ID = 'userSwitch';
export const SUCCESS_CONTENT_ID = 'successContent';
export const BACK_BUTTON_ID = 'backButtonId';
export const RESEND_EMAIL_BUTTON_ID = 'resendEmailButton';
export const buildMemberMenuItemId = (id: string) => `memberMenuItemId-${id}`;
export const PASSWORD_SUCCESS_ALERT = 'passwordSuccessAlert';

export const PLATFORM_ADVERTISEMENT_CONTAINER_ID =
  'platformAdvertisementContainer';

export const REDIRECTION_CONTENT_CONTAINER_ID = 'redirectionContentContainer';

export const ERROR_DISPLAY_ID = 'errorDisplay';
